<template>
    <v-container>
        <v-layout row wrap v-on:click="loadData">
            <div id="divPrint">
                <v-form ref="form" v-model="valid">
                    <v-expansion-panel v-model="panel" expand>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>SECCIÓN I - EDIFICIOS, LOCALES, INSTALACIONES Y ÁREAS DE LA EMPRESA</div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Los edificios, locales, instalaciones y áreas de la empresa están en buenas
                                        condiciones? (2.5 metros de altura, superficie de 2 m2 por trabajador)
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[0]" :items="itemsRespuesta" label="Seleccione"
                                                  required></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las características de las edificaciones e instalaciones están acordes con
                                        la actividad que se realiza?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[1]" :items="itemsRespuesta" label="Seleccione"
                                                  required></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Los pisos cuentan con superficies antirresbalantes y se encuentran libres de
                                        daños?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[2]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Las paredes están pintadas en colores claros mate que contrastan con los
                                        equipos y maquinaria?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[3]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Los pasillos de tránsito están delimitados y se puede caminar con seguridad?
                                        (Los locales y edificios cuentan con salidas normales para permitir el desalojo
                                        en un máximo de 3 minutos):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[4]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        6. ¿Las rutas y salidas de emergencia están señaladas, en buenas condiciones y
                                        sin obstrucciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[5]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        7. ¿Las áreas y patios de maniobras están perfectamente delimitados con señales
                                        y franjas de color amarillo?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[6]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        8. ¿Los desniveles, zanjas, registros y drenajes cuentan con avisos de seguridad
                                        y protecciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[7]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        9. ¿Las escaleras, escalas fijas y plataformas o pisos de trabajo elevados
                                        cuentan con protecciones y están sin deterioro? (Escaleras: ancho mínimo de 56
                                        cm, huellas de 25 cm y peraltes de 18 cm; barandales a 90 cm. Escalas fijas:
                                        ancho 40 cm, no mayor de 30 cm entre peldaños, descansos cada 10 m, con
                                        protección circundante de 90 cm y separadas de la pared 20 cm):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[8]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        10. ¿Las escaleras que tengan un ancho de 3 m o más cuentan con una barandilla o
                                        pasamanos intermedio?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[9]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        11. ¿En las escaleras que están cubiertas en su pared lateral con muros se
                                        dispone, por lo menos, de un pasamanos con una altura no menor de 80 cm ni mayor
                                        de 90 cm?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[10]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        12. ¿Las escaleras fijas tienen un ancho mínimo de 40 cm y una distancia entre
                                        peldaños no mayor de 30 cm?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[11]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        13. ¿Las escaleras marinas fijas tienen protección circundante a partir de 2 m
                                        del piso y hasta 90 cm por encima del último nivel al que asciende?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[12]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN II - ORDEN Y LIMPIEZA
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿En los lugares elevados como pasillos, escaleras y plataformas, se prohíbe
                                        colocar materiales o herramientas que puedan caer sobre los trabajadores?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[13]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Los locales y puestos de trabajo, en general se encuentran ordenados y
                                        limpios?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[14]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Se cuenta con botes de basura y recipientes especiales para residuos
                                        reciclables y contaminantes químicos y biológicos?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[15]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Se tienen botes de basura para clasificar el tipo de desecho?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[16]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Los vestidores, casilleros y baños están ordenados y limpios?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[17]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        6. ¿Los sitios para tomar alimentos y áreas de descanso están ordenados y libres
                                        de basura?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[18]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        7. ¿Se cuenta con un lugar especial para disponer temporalmente de los diversos
                                        tipos de basura?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[19]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN III - SISTEMAS CONTRA INCENDIO
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Está visible la relación de la brigada, cuadrilla o cuerpo de bomberos
                                        contra incendio?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[20]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿El equipo de protección respectivo está a la mano?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[21]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Los equipos contra incendio están en su sitio y en condiciones de uso
                                        inmediato?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[22]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Los equipos que generan electricidad estática están conectados a tierra?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[23]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Los equipos contra incendio están en lugares de fácil acceso y señalada su
                                        ubicación? (Distancia no mayor de 15 m entre cada uno, y una altura máxima de
                                        1.5 m del piso a la parte más alta del extintor):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[24]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        6. ¿La empresa tiene instalados detectores de humo o de calor?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[25]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        7. ¿Cuenta con un sistema de aspersores o de otro tipo?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[26]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        8. ¿Se dispone de un sistema de alarma luminosa o sonora?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[27]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        9. ¿Están identificados y señalados los materiales e instalaciones para prevenir
                                        y combatir incendios?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[28]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        10. ¿Cuenta con un sistema de hidrantes?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[29]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN IV - INSTALACIONES ELÉCTRICAS
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Las instalaciones eléctricas de alumbrado general tienen dispositivos de
                                        seguridad?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[30]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las instalaciones eléctricas están fijas y entubadas debidamente y no
                                        existen conexiones o instalaciones provisionales?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[31]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Las líneas eléctricas se encuentran identificadas y señaladas, según
                                        voltaje?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[32]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Los tableros de control cuentan con cerraduras o candados y, en caso de
                                        reparación, con las etiquetas correspondientes?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[33]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Las áreas donde existe equipo de alta tensión cuentan con avisos de peligro
                                        y sólo el personal autorizado tiene acceso a estas zonas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[34]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN V - MANEJO, TRANSPORTE Y ALMACENAMIENTO DE MATERIALES
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Se cuenta con lugares especiales para estiba y desestiba, bien iluminados y
                                        delimitados?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[35]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Se encuentra señalada la altura máxima de estabilidad de las estibas por
                                        tipo de producto?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[36]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Las estibas están en su almacén respectivo, bien ordenadas y a la altura
                                        correspondiente?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[37]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Los estantes de los almacenes están debidamente fijos y estables para evitar
                                        su caída?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[38]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Las bandas y transportadores tienen dispositivos de paro en caso de
                                        emergencia?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[39]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN VI - SEÑALES, AVISOS DE SEGURIDAD Y CÓDIGO DE COLORES
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Existen señales y avisos de seguridad e higiene para evitar accidentes y
                                        enfermedades de trabajo?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[40]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿En las señales y avisos se enfatizan los aspectos preventivos de accidentes
                                        y enfermedades de trabajo?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[41]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Están colocados en lugares visibles y sitios adecuados?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[42]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Dichos señalamientos se mantienen en buenas condiciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[43]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Se utiliza la identificación de riesgos por fluidos conducidos por tuberías?
                                        (Rojo: identificación de tuberías contra incendios; Amarillo: identificación de
                                        fluidos peligrosos; Verde: identificación de fluidos de bajo riesgo):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[44]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        6. ¿Se utilizan adecuadamente en toda la empresa los colores de seguridad?
                                        (Rojo: Paro, prohibición, material, equipo y sistemas para combate de incendios;
                                        Amarillo: Advertencia de peligro, delimitación de áreas y advertencia de peligro
                                        por radiaciones ionizantes; Verde: Condición segura; Azul: Obligación):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[45]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        7. ¿La pintura de los dos puntos anteriores está en buenas condiciones y es
                                        fotoluminiscente?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[46]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        8. ¿Los avisos y señales son claros y precisos?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[47]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN VII - RUIDO
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Es posible la comunicación oral a un metro de distancia?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[48]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las áreas con exposición a ruido se encuentran bien delimitadas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[49]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Se utilizan dispositivos y materiales para atenuar la magnitud del ruido y
                                        disminuir su propagación?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[50]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿El personal expuesto a ruido usa el equipo de protección personal adecuado?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[51]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN VIII - VIBRACIONES
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Las fuentes generadoras de vibraciones están debidamente identificadas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[52]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las máquinas generadoras de vibraciones están adecuadamente cimentadas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[53]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Las máquinas que generan vibraciones están ajustadas y cuentan con los
                                        dispositivos antivibratorios necesarios?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[54]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿La maquinaria generadora de vibraciones se encuentra separada de paredes que
                                        puedan transmitir las vibraciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[55]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Las zonas donde se producen vibraciones se encuentran adecuadamente
                                        señaladas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[56]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN IX - RADIACIONES IONIZANTES Y NO IONIZANTES
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Existe señalización adecuada sobre la exposición a radiaciones ionizantes y
                                        no ionizantes?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[57]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿El personal expuesto porta y utiliza adecuadamente los dosímetros?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[58]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Se cuenta con dispositivos de seguridad para el control de las radiaciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[59]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿El personal expuesto utiliza el equipo de protección personal adecuado?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[60]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN X - CONDICIONES TÉRMICAS EXTREMAS
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Se utiliza equipo de protección personal para desarrollar actividades en
                                        cámaras de refrigeración?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[61]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Se utiliza equipo de protección personal para desarrollar actividades en
                                        áreas generadoras de calor?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[62]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Las áreas de temperaturas abatidas cuentan con sistemas de seguridad que
                                        permiten abrir las puertas desde el interior?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[63]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Las áreas de temperatura abatida cuentan con alarma sonora y luminosa?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[64]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿En las áreas de exposición a calor existen depósitos accesibles de agua o
                                        líquidos en cantidad suficiente?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[65]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN XI - VENTILACIÓN
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Se mantiene durante las labores la ventilación necesaria para impedir el
                                        daño a la salud de los trabajadores?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[66]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Se cuenta con señalización en las áreas donde existe riesgo de exposición a
                                        deficiencia de oxígeno?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[67]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Se cuenta con sistemas de ventilación en las áreas donde se producen,
                                        manejan o almacenan sustancias combustibles, irritantes, corrosivas, tóxicas,
                                        inflamables o explosivas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[68]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN XII - ILUMINACIÓN
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿El centro de trabajo cuenta con iluminación suficiente y adecuada, conforme
                                        al tipo de proceso u operación que se realiza?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[69]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las áreas y puestos de trabajo están libres de deslumbramientos directos o
                                        por reflexión?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[70]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Los puestos de trabajo tienen un fondo visual adecuado a las actividades de
                                        los trabajadores?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[71]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿La empresa tiene en funcionamiento un sistema de iluminación de emergencia?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[72]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN XIII - HERRAMIENTAS, EQUIPOS Y MAQUINARIA
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Las herramientas de mano se encuentran en buenas condiciones de uso?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[73]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las herramientas, enchufes y cables eléctricos están en buenas condiciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[74]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Las herramientas eléctricas están conectadas a tierra?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[75]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Las tomas de aire, herramientas y equipos neumáticos están en buenas
                                        condiciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[76]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Las máquinas y equipos con movimiento cuentan con guardas protectoras y
                                        dispositivos de seguridad?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[77]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        6. ¿Los dispositivos de paro de emergencia están visibles y funcionan
                                        adecuadamente?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[78]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        7. ¿Los cables, cadenas, estrobos y ganchos de las grúas y equipos para izar se
                                        encuentran en buenas condiciones?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[79]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        8. ¿Las plataformas están marcadas con su capacidad y en buen estado?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[80]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        9. ¿Se usan barreras antichoque en la planta?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[81]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        10. ¿Los equipos de soldadura y corte operan en áreas específicas y en
                                        condiciones de seguridad e higiene?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[82]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        11. ¿Los montacargas y grúas móviles y fijas cuentan con señales de seguridad
                                        sonoras y luminosas, extintores, y señalada la carga que pueden mover
                                        (kilogramos)?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[83]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN XIV - AGENTES CONTAMINANTES BIOLÓGICOS
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">

                                        1. ¿Los recipientes o contenedores contaminados con agentes biológicos están
                                        adecuadamente identificados y cuentan con mecanismos de seguridad? (Tapa de
                                        cierre hermético, tapa de un sólo sentido):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[84]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las áreas de riesgo de exposición a agentes biológicos están adecuadamente
                                        identificadas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[85]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿El personal que maneja materiales o recipientes contaminados con agentes
                                        biológicos, utiliza el equipo de protección personal adecuado?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[86]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿El personal que manipula material contaminado está autorizado para ello?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[87]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿En las áreas contaminadas con biológicos, se dispone de mecanismo para
                                        descontaminación inmediata del trabajador? (regadera, lavamanos, etcétera):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[88]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN XV - MATERIALES Y SUSTANCIAS QUÍMICAS PELIGROSAS
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Están adecuadamente señaladas las áreas donde se almacenan o existe el
                                        riesgo de exposición a sustancias químicas peligrosas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[89]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Las zonas donde se almacenan o utilizan sustancias químicas cuentan con
                                        buena iluminación?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[90]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Las áreas donde se utilizan o almacenan sustancias químicas peligrosas
                                        cuentan con una ventilación adecuada?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[91]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Las áreas donde se manejan sustancias químicas peligrosas cuentan con zonas
                                        de descontaminación o regadera?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[92]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿En las áreas de producción solamente se cuenta con las cantidades necesarias
                                        de sustancias químicas que se utilizarán durante la jornada de trabajo?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[93]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        6. ¿Se encuentra señalada la restricción de acceso a áreas confinadas en donde
                                        se almacenan o manejan sustancias químicas, tóxicas o peligrosas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[94]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        7. ¿Las instalaciones donde se manejan sustancias químicas cuentan con
                                        dispositivos para evitar derrames o fuga y su dispersión?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[95]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        8. ¿Los recipientes fijos para almacenar líquidos corrosivos o materiales
                                        tóxicos o irritantes están llenados máximo al 90% de su volumen y provistos de
                                        dispositivos de seguridad?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[96]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        9. ¿Los recipientes que contienen sustancias químicas peligrosas cuentan con
                                        avisos y señales de seguridad y se pueden cerrar herméticamente?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[97]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        10. ¿Los tanques y contenedores de sustancias flamables están conectados a
                                        tierra?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[98]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        11. ¿Los cilindros de gases comprimidos están debidamente separados por
                                        contenido, asegurados para evitar su caída, alejados de materiales reactivos y
                                        con protección o capucha en la válvula?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[99]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        12. ¿Los tanques de gas estacionario están provistos de válvulas y manómetros de
                                        operación y válvulas de seguridad?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[100]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        13. ¿Las tuberías, tanques y cilindros de gas están alejados de fuentes de
                                        calor, en zonas bien ventiladas o aislados con materiales incombustibles?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[101]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        14. ¿El personal que maneja sustancias químicas peligrosas cuenta con el equipo
                                        de protección personal adecuado?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[102]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                            <template v-slot:header>
                                <div>
                                    SECCIÓN XVI - SERVICIOS PARA LOS TRABAJADORES
                                </div>
                            </template>
                            <ul>
                                <li>
                                    <td width="900px">
                                        1. ¿Los trabajadores cuentan con bebederos o recipientes de agua purificada y
                                        vasos higiénicos?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[103]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        2. ¿Existen vestidores dotados de casilleros y regaderas?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[104]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        3. ¿Se cuenta con tazas de baño y mingitorios en buen estado?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[105]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        4. ¿Existe comedor o un lugar especial para el consumo de alimentos?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[106]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        5. ¿Se cuenta con áreas de descanso para los trabajadores?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[107]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        6. ¿Se tiene servicio médico para el personal de la empresa? (más de 100
                                        trabajadores):
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[108]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                                <li>
                                    <td width="900px">
                                        7. ¿Dicho servicio dispone de medicamentos, material de curación y personal de
                                        primeros auxilios?:
                                    </td>
                                    <td width="200px">
                                        <v-select v-model="answers[109]" :items="itemsRespuesta"
                                                  label="Seleccione"></v-select>
                                    </td>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-form>
            </div>
        </v-layout>
        <div class="text-xs-center">
            <v-btn class="no-print" color="primary" @click="print" dark>Imprimir</v-btn>
            <v-btn color="primary" @click="submit" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="closeAlert"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import GuiaProessatData from "../../../model/GuiaProessatData";

    export default {
        props: ['guia-proessat', 'answersData'],
        data: () => ({
            valid: false,
            dialogSuccess: false,
            itemsRespuesta: ['Si', 'No', 'Parcialmente', 'No Aplica'],
            name: "",
            email: "",
            select: null,
            answers: [],
            answersForSave: [],
            momentos: [
                "Seleccionar",
                "Antes de la jornada",
                "Durante la jornada",
                "Después de la jornada",
                "En un día de descanso"
            ],
            sexo: ["Seleccionar", "Masculino", "Femenino"],
            escolaridad: [
                "Seleccionar",
                "Primaria incompleta",
                "Primaria completa",
                "Secundaria incompleta",
                "Secundaria completa",
                "Universidad incompleta",
                "Universidad completa",
                "Carrera técnica",
                "Cuarto nivel"
            ],
            estadoCivil: [
                "Seleccionar",
                "Soltero(a)",
                "Casado(a)",
                "Divorciado(a)",
                "Unión libre",
                "Viudo(a)"
            ],
            siNo: ["Seleccione", "Si", "No"],
            checkbox: null,
            dictionary: {
                attributes: {
                    email: "E-mail Address"
                    // custom attributes
                },
                custom: {
                    name: {
                        required: () => "Name can not be empty",
                        max: "The name field may not be greater than 10 characters"
                        // custom messages
                    },
                    select: {
                        required: "Select field is required"
                    }
                }
            },
            panel: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
        }),
        methods: {
            closeAlert() {
                this.$store.dispatch('getGuiasProessatByCompany', this.guiaProessat.company.id).then(
                    response => {
                        this.dialogSuccess = false
                        this.answers = []
                        this.$emit('clickedSomething')
                        this.$forceUpdate();
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },
            loadData() {
                this.answers = this.answersData
            },
            submit() {
                this.answersData = [];
                    for (let i = 0; i < this.answers.length; i++) {
                        if (this.answers[i] != null && typeof this.answers[i] !== 'undefined') {
                            let data = new GuiaProessatData();
                            data.answer = this.answers[i];
                            data.questionNumber = i;
                            data.guiaProessat = this.guiaProessat
                            this.answersForSave.push(data)
                        }
                    }
                    this.guiaProessat.guiaProessatData = this.answersForSave
                    this.guiaProessat.company = this.$store.state.company
                    if (this.guiaProessat.id == "") {
                        this.$store.dispatch('addGuiaProessat', this.guiaProessat).then(response => {
                            this.dialogSuccess = true
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    } else {
                        this.$store.dispatch('updateGuiaProessat', this.guiaProessat).then(response => {
                            this.dialogSuccess = true
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }

            },
            clear() {
                this.name = "";
                this.email = "";
                this.select = null;
                this.checkbox = null;
                //this.$validator.reset()
            },
            print(){
                this.$store.state.drawer = false
                this.$store.state.toolbar = false
                setTimeout(function(){
                    window.print()
                }, 1000);
                let self=this
                setTimeout(function(){
                    self.$store.state.toolbar = true
                }, 3000);
            }
        },
        created() {
            this.loadData()
        }

    };
</script>


// WEBPACK FOOTER //
// src/components/company/guiaProessat/GuiaProessatData.vue